import React from "react";
import { BiChevronLeft } from "react-icons/bi";
import { BsChevronDoubleLeft } from "react-icons/bs";
import { GrUserSettings } from "react-icons/gr";

const index = ({ onClick, item }) => {
  return (
    <div className="groupingitem" onClick={onClick}>
      <p className="teXt">{item.title + (item.need_expense ? '(دسته بندی پولی)' :'')}</p>
      {item?.childs?.length > 0 && <BiChevronLeft size="1.2rem" />}
    </div>
  );
};

export default index;
